/**
 * 内置快捷工具栏项聚合：各子文件仅关心具体渲染逻辑，由此处统一组装 key / sort / render。
 */
import type { IShortcutMenuItem } from '../type';
import { aiTextShortcutItemRender } from './ai-text-item';
import { moreMenuShortcutItemRender } from './more-menu-item';

const builtinShortcutMenuItems: IShortcutMenuItem[] = [
    {
        key: 'ai-text-item-20',
        sort: 20,
        render: aiTextShortcutItemRender,
    },
    {
        key: 'more-menu-120',
        sort: 120,
        render: moreMenuShortcutItemRender,
    },
];

/** 业务可通过 ShortcutMenu#setItems 全量替换或通过 #addItems 追加 */
export function getBuiltinShortcutMenuItems(): IShortcutMenuItem[] {
    return builtinShortcutMenuItems;
}
